export default "__VITE_ASSET__CSsIKKQP__"